import * as REPORT_TYPES from "./actionTypes";

export const initialState = {
    isLoading: false,
    success: false,
    payload: {},
    errors: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORT_TYPES.GET_WARRANTIES_REPORT: {
            return { ...state, payload: action.data, isLoading: true };
        }
        case REPORT_TYPES.GET_WARRANTIES_REPORT_SUCCESS: {
            return {
                ...state,
                success: true,
                errors: null,
                isLoading: false,
            };
        }
        case REPORT_TYPES.GET_WARRANTIES_REPORT_FAILURE: {
            return {
                ...state,
                success: false,
                errors: action.errors,
                isLoading: false,
            };
        }
        case REPORT_TYPES.RESET_WARRANTIES_REPORT: {
            return {
                ...state,
                success: false,
                errors: null,
                isLoading: false,
                payload: {}
            };
        }
        default:
            return state;
    }
};

export default reducer;
